import { useState, useRef, useEffect } from 'react';
import { MoreVerticalIcon, ChevronDownIcon } from 'lucide-react';

function DropdownMenu({ trigger, children, align = 'right' }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const alignmentClasses = {
    left: 'left-0',
    right: 'right-0',
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-2 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-all duration-200 font-medium dark:bg-slate-700 dark:text-slate-300 dark:hover:bg-slate-600 transform hover:scale-[1.02] hover:shadow-lg active:scale-[0.98]"
      >
        {trigger || (
          <>
            <MoreVerticalIcon className="h-4 w-4 mr-2" />
            <span>More Actions</span>
            <ChevronDownIcon className={`h-4 w-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
          </>
        )}
      </button>

      {isOpen && (
        <div className={`absolute ${alignmentClasses[align]} mt-2 w-56 rounded-lg shadow-lg bg-white dark:bg-slate-800 ring-1 ring-black ring-opacity-5 z-50`}>
          <div className="py-1" onClick={() => setIsOpen(false)}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

function DropdownItem({ icon: Icon, onClick, children, variant = 'default', disabled = false }) {
  const variantClasses = {
    default: 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700',
    danger: 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center px-4 py-2 text-sm transition-colors ${variantClasses[variant]} ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      }`}
    >
      {Icon && <Icon className="h-4 w-4 mr-3" />}
      {children}
    </button>
  );
}

function DropdownDivider() {
  return <div className="h-px bg-slate-200 dark:bg-slate-700 my-1" />;
}

export { DropdownMenu, DropdownItem, DropdownDivider };
export default DropdownMenu;
